import { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import { PropsWithTestId } from '../../../../../types';
import cn from 'classnames';
import styles from './MobileFilterButton.module.scss';
import useBrand from '../../../../../hooks/useBrand';

export interface MobileFilterButtonProps
  extends PropsWithTestId<
    PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>
  > {
  iconName?: string;
}

export function MobileFilterButton(props: MobileFilterButtonProps) {
  const { iconName, children, className, testId, ...restProps } = props;
  const { secondaryColor } = useBrand();

  const buttonClassNames = cn(styles.button, className);

  return (
    <button
      {...restProps}
      className={buttonClassNames}
      data-testid={testId}
      style={{ border: `1px solid ${secondaryColor}` }}
    >
      {iconName && (
        <span
          className={cn('material-icons', styles.icon)}
          data-testid="toggle-button-icon"
          style={{ color: secondaryColor }}
        >
          {iconName}
        </span>
      )}
      <span className={styles.label}>{children}</span>
    </button>
  );
}

MobileFilterButton.defaultProps = {
  testId: 'toggle-filter-button-action',
};
